import { AutogenModelCommitmentHistory, AutogenRowCommitmentHistory } from "./autogen/AutogenModelCommitmentHistory";

export class ModelCommitmentHistory extends AutogenModelCommitmentHistory<RowCommitmentHistory> {
	constructor() {
		super(RowCommitmentHistory);
	}
}

export class RowCommitmentHistory extends AutogenRowCommitmentHistory {
}